import store from "../store";
import vue from "../main";
import nepalidate from "./nepalidate";

export default {
  weekDayList: [
    { text: vue.$t("language.sun"), value: 1 },
    { text: vue.$t("language.mon"), value: 2 },
    { text: vue.$t("language.tue"), value: 3 },
    { text: vue.$t("language.wed"), value: 4 },
    { text: vue.$t("language.thu"), value: 5 },
    { text: vue.$t("language.fri"), value: 6 },
    { text: vue.$t("language.sat"), value: 7 },
  ],
  genderList: ["All", "Male", "Female"],
  statusList: [
    "Death",
    "Retirement",
    "Resignation",
    "Terminated",
    "Transferred",
    "Working",
  ],
  AttendanceTypeList: [
    { name: vue.$t("language.attendance"), id: "attendance" },
    { name: vue.$t("language.present"), id: "present" },
    { name: vue.$t("language.absent"), id: "absent" },
    { name: vue.$t("language.holiday"), id: "holiday" },
    { name: vue.$t("language.leave"), id: "leave" },
    { name: vue.$t("language.weekend"), id: "weekend" },
    { name: vue.$t("language.officialvisit"), id: "officialvisit" },
    { name: vue.$t("language.lateinearlyout"), id: "lateinearlyout" },
  ],
  maritalStatusList: ["Single", "Married"],
  LateInEarlyOutStatusList: [
    { name: vue.$t("language.notnotified"), id: "notnotified" },
    { name: vue.$t("language.pending"), id: "pending" },
    { name: vue.$t("language.approved"), id: "approved" },
    { name: vue.$t("language.rejected"), id: "rejected" },
  ],
  LateInEarlyOutList: [
    { name: vue.$t("language.latein"), id: "LateIn" },
    { name: vue.$t("language.earlyout"), id: "EarlyOut" },
  ],
  DaysAssignmentTypeList: [
    { name: vue.$t("language.assigned"), id: "ASSIGNED" },
    { name: vue.$t("language.transferred"), id: "TRANSFERRED" },
  ],
  NepaliMonthList: [
    { name: vue.$t("language.baisakh"), id: 1 },
    { name: vue.$t("language.jestha"), id: 2 },
    { name: vue.$t("language.asadh"), id: 3 },
    { name: vue.$t("language.shrawan"), id: 4 },
    { name: vue.$t("language.bhadra"), id: 5 },
    { name: vue.$t("language.ashoj"), id: 6 },
    { name: vue.$t("language.kartik"), id: 7 },
    { name: vue.$t("language.mangsir"), id: 8 },
    { name: vue.$t("language.poush"), id: 9 },
    { name: vue.$t("language.magh"), id: 10 },
    { name: vue.$t("language.falgun"), id: 11 },
    { name: vue.$t("language.chaitra"), id: 12 },
  ],
  EnglishMonthList: [
    { name: vue.$t("language.january"), id: 1 },
    { name: vue.$t("language.february"), id: 2 },
    { name: vue.$t("language.march"), id: 3 },
    { name: vue.$t("language.april"), id: 4 },
    { name: vue.$t("language.may"), id: 5 },
    { name: vue.$t("language.june"), id: 6 },
    { name: vue.$t("language.july"), id: 7 },
    { name: vue.$t("language.august"), id: 8 },
    { name: vue.$t("language.september"), id: 9 },
    { name: vue.$t("language.october"), id: 10 },
    { name: vue.$t("language.november"), id: 11 },
    { name: vue.$t("language.december"), id: 12 },
  ],
  validFileSize(file) {
    if (file.size > 1024 * 1024) {
      store.dispatch(
        "showErrorMessage",
        "Please upload file with size 1MB or less"
      );
      return false;
    }
    return true;
  },
  getDays(startdate, enddate) {
    if (startdate == null || enddate == null) return 0;
    var diffTimespan =
      new Date(enddate).getTime() - new Date(startdate).getTime();
    return Math.ceil(diffTimespan / (1000 * 3600 * 24)) + 1;
  },
  convertToQueryString: function(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        if (obj[p] != null)
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  },
  getDefaultDate: function(engDate) {
    return store.getters.settings.datetype == "BS"
      ? nepalidate.convertToNepaliDate(engDate)
      : engDate;
  },
  getCurrentYear: function() {
    return store.getters.settings.datetype == "BS"
      ? nepalidate.parseNepaliDate(nepalidate.getTodayNepaliDate()).year
      : new Date().getFullYear();
  },
  getCurrentMonth: function() {
    return store.getters.settings.datetype == "BS"
      ? parseInt(
          nepalidate.parseNepaliDate(nepalidate.getTodayNepaliDate()).month
        )
      : new Date().getMonth() + 1;
  },
  getMonthName: function(id) {
    let list =
      store.getters.settings.datetype == "BS"
        ? this.NepaliMonthList
        : this.EnglishMonthList;
    return list.filter((item) => {
      return item.id == id;
    })[0].name;
  },
  getMonthList: function() {
    return store.getters.settings.datetype == "BS"
      ? this.NepaliMonthList
      : this.EnglishMonthList;
  },
  getTimeDifferenceInHour(startTime, endTime) {
    var patt = /(2[0-3]|[01]?[0-9]):([0-5]?[0-9])/i;
    if (
      startTime == null ||
      endTime == null ||
      !patt.test(startTime) ||
      !patt.test(endTime)
    )
      return 0;
    else {
      var timeStart = new Date("01/01/2007 " + startTime).getHours() + (new Date("01/01/2007 " + startTime).getMinutes()/60);
      var timeEnd = new Date("01/01/2007 " + endTime).getHours() + (new Date("01/01/2007 " + endTime).getMinutes()/60);

      var hourDiff = timeEnd - timeStart;
      if (hourDiff < 0) {
        hourDiff = 24 + hourDiff;
      }
      return hourDiff;
    }
  },
};
